import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { currencyFormat } from 'utilities/common';

export const Detail = ({ customer, data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Customer.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="customer">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Informasi Customer
        </div>
      )}

      <div className="row mb-4">
        {StateLoading || !customer ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <>
            <div className="row">
              <div className="col-6">
                <ListHorizontal
                  title="Customer"
                  content={
                    customer?.company_name !== ''
                      ? `${customer?.company_name} - ${customer?.name}`
                      : customer?.name
                  }
                />
                <ListHorizontal
                  title="Alamat"
                  content={customer?.address}
                />
              </div>
              {data && (
                <div className="col-6">
                <ListHorizontal
                  title="Total Acc.Receivable"
                  content={currencyFormat(data?.acc_receivable)}
                />
                <ListHorizontal
                  title="Total OS"
                  content={currencyFormat(data?.total_charges)}
                />
              </div>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );
};